import React from 'react';
import { useTranslation } from 'react-i18next';
import { LOGIN_URL, VCALL_CALL_URL } from 'config';
import { translateToHTML } from 'jitsi/base/i18n/functions';
import ActionButton from 'features/PreMeetingScreen/ActionButton';
import JitsiThemeProvider from 'jitsi/base/ui/components/JitsiThemeProvider.web';
import { LogoContainer } from './LogoContainer';
const loginSubmit = () => {
    localStorage.setItem('redirect_back', window.location.href);
    if (window.location !== window.parent.location) {
        window.open(LOGIN_URL, '_blank', 'noopener');
    }
    else {
        window.location.href = LOGIN_URL;
    }
};
export const WaitingRoom = ({ user, room }) => {
    const { t } = useTranslation();
    const renderWaitingText = () => {
        if ([2, 3].indexOf(room.room_type) > -1) {
            if (window.self !== window.top) {
                return translateToHTML(t, 'waitingpage.virtual_office_text_iframe', {
                    userFullName: room.owner_user.fullname,
                });
            }
            else {
                return translateToHTML(t, 'waitingpage.virtual_office_text', {
                    userFullName: room.owner_user.fullname,
                    userCallURL: `${VCALL_CALL_URL}/${room.owner_user.user_slug}`,
                });
            }
        }
        return translateToHTML(t, 'waitingpage.default_text', { roomName: room.name });
    };
    return (React.createElement(JitsiThemeProvider, null,
        React.createElement("div", { className: 'pageContainer' },
            React.createElement(LogoContainer, null),
            React.createElement("div", { className: 'whiteContainerBox' }, (!window.APP?.room?.conference_options?.host_login_button && window.APP?.room?.conference_options?.login_page_text) ?
                React.createElement("div", { className: 'waitingContent' },
                    React.createElement("div", { style: {
                            margin: '20px',
                            fontSize: 'medium',
                            overflowWrap: 'anywhere'
                        } }, React.createElement("div", { style: { marginTop: '11px' }, dangerouslySetInnerHTML: { __html: window.APP?.room?.conference_options?.login_page_text } })))
                :
                    React.createElement("div", { className: 'waitingContent' },
                        React.createElement("div", { style: { margin: '20px', fontSize: 'medium' } },
                            renderWaitingText(),
                            !user && React.createElement("div", { style: { marginTop: '11px' } }, t('waitingpage.auth_text'))),
                        !user && window.APP?.room?.conference_options?.host_login_button && (React.createElement(ActionButton
                        // style={{ margin: '0 auto', marginTop: '20px' }}
                        // type='button'
                        , { 
                            // style={{ margin: '0 auto', marginTop: '20px' }}
                            // type='button'
                            className: 'loginSubmitButton', onClick: loginSubmit }, t('waitingpage.login_button_text'))))))));
};
export default WaitingRoom;
